import React, { useState } from "react";
import { useCommentData } from "./CommentDataContext";
import SendIcon from "@mui/icons-material/Send";
import "./SubmitComment.css";
const SubmitComment = () => {
  const [commentInput, setCommentInput] = useState("");

  const { activeTab, username, selectedQuery } = useCommentData();

  const handleAddComment = () => {
    if (!selectedQuery) {
      alert("No entry selected to add comment");
      return;
    }
    if (!commentInput.trim()) return;

    const now = new Date();
    const date = now.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const time = now
      .toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .toUpperCase();
    const newComment = {
      username,
      text: commentInput.trim(),
      date,
      time,
    };
    window.canvasEngine.FeatureRenderer.addComment(
      newComment,
      activeTab,
      selectedQuery.id
    );

    setCommentInput("");
  };

  return (
    <div className="comment-input-group">
      <textarea
        value={commentInput}
        onChange={(e) => setCommentInput(e.target.value)}
        placeholder="Add a comment..."
        aria-label="Comment Input"
        className="comment-input"
        rows={5}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleAddComment();
          }
        }}
      />
      <button className="comment-submit" onClick={handleAddComment}>
        <SendIcon />
      </button>
    </div>
  );
};

export default SubmitComment;
